import { useQuery } from "@apollo/client";
import { GetOrderDesignsDocument } from "../../gql/generated/graphql";
import type { OrderDesignStatus } from "@jasper/client-models";

export const useAllOrderDesigns = ({
  take,
  skip,
  statuses,
  onlyUntranslatedComment,
}: {
  take: number;
  skip: number;
  statuses?: OrderDesignStatus[];
  onlyUntranslatedComment: boolean;
}) => {
  const { data, loading, error } = useQuery(GetOrderDesignsDocument, {
    variables: {
      take: take,
      skip: skip,
      statuses,
      onlyUntranslatedComment: onlyUntranslatedComment,
    },
    fetchPolicy: "cache-and-network",
  });

  return {
    isLoading: loading,
    error: error,
    allOrderDesigns: data?.getOrderDesigns.rows ?? [],
    totalCount: data?.getOrderDesigns.totalCount ?? 0,
  };
};
